import React from 'react';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import BaseTimelineRecordLayout from 'domain/shared/timeline/layout/BaseTimelineRecordLayout';
import { DATE_FORMAT } from 'framework/utils';
import { Collapsible, DateField, BadgeField } from 'framework/ui/field';
import { KPI_STRUCTURE_ADD, KPI_STRUCTURE_UPDATE } from './useKPIService';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { useShowContext } from 'framework/show';
import { ShowSection } from 'framework/ui/layout';
import CopyKpiStructureButton from './shared/buttons/CopyKPIStructureButton';
import KpiParametersListField from './shared/fields/KPIParametersListField';
import KpiStatusBadge from './shared/fields/KPIStatusBadge';

const ServiceKPIStructureRecordLayout = ({ onEdit, ...props }: any) => {
  const { data } = useShowContext();

  const buttons = [
    <EditTimelineRecordButton onEdit={onEdit} permissionToCheck={KPI_STRUCTURE_UPDATE} />,
    <CopyKpiStructureButton permissionToCheck={KPI_STRUCTURE_ADD} />,
  ];

  return (
    <BaseTimelineRecordLayout
      timelineType={TimelineType.NOTE}
      buttons={buttons}
      entity={data}
      {...props}
      fields={
        <Collapsible>
          <ShowSection>
            <BadgeField
              style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
              }}
              widht="1000px"
              badges={[<KpiStatusBadge label="Status" source="status" />]}
            >
              <DateField label="Effective Date" source="effectiveDate" dateFormat={DATE_FORMAT.API_ONLY_MONTH} />
            </BadgeField>
            <KpiParametersListField source="kpiParameters" dateSource="effectiveDate" />
          </ShowSection>
        </Collapsible>
      }
    />
  );
};

export default ServiceKPIStructureRecordLayout;
